import { createAction } from '@reduxjs/toolkit';
import { IAutocompleteField } from 'types/shared';
import {
  ChangedKontentRequest,
  ChangedProductsDTO,
  JobsErrorCodeIgnoreDTO,
  KontentProjectLanguageMappingDTO,
  Page,
  ProjectDTO,
  XTMWorkflowStepDTO,
} from 'utils/restApplicationClient';
import { ProjectsActionTypes } from './projects.actions.types';
import {
  IProjectCheckPayload,
  IQueuePagination,
  ModifyLanguagesPayload,
  ProjectCheckArray,
  ProjectErrorArray,
} from './projects.interface';

export const setProjectsPagination = createAction<IQueuePagination>(ProjectsActionTypes.SetPagination);

export const getProjects = createAction(ProjectsActionTypes.GetProjects);

export const getProjectsSuccess = createAction<Page<ProjectDTO>>(ProjectsActionTypes.GetProjectSuccess);

export const getProjectsError = createAction(ProjectsActionTypes.GetProjectError);

export const exportListToFile = createAction(ProjectsActionTypes.ExportListToFile);

export const exportListToFileSuccess = createAction<Blob>(ProjectsActionTypes.ExportListToFileSuccess);

export const exportListToFileError = createAction(ProjectsActionTypes.ExportListToFileError);

export const changeDueDateJob = createAction<{ jobId: string; dueDate: Date }>(ProjectsActionTypes.ChangeDueDateJob);

export const changeDueDateJobError = createAction(ProjectsActionTypes.ChangeDueDateJobError);

export const changeDueDateJobSuccess = createAction(ProjectsActionTypes.ChangeDueDateJobSuccess);

export const changeDueDateProject = createAction<{ projectId: string; dueDate: Date }>(
  ProjectsActionTypes.ChangeDueDateProject,
);

export const changeDueDateProjectError = createAction(ProjectsActionTypes.ChangeDueDateProjectError);

export const changeDueDateProjectSuccess = createAction(ProjectsActionTypes.ChangeDueDateProjectSuccess);

export const modifyLanguages = createAction<ModifyLanguagesPayload>(ProjectsActionTypes.ModifyLanguages);

export const modifyLanguagesError = createAction(ProjectsActionTypes.ModifyLanguagesError);

export const modifyLanguagesSuccess = createAction(ProjectsActionTypes.ModifyLanguagesSuccess);

export const contentChangedUpdate = createAction<ChangedKontentRequest>(ProjectsActionTypes.ContentChangedUpdate);

export const contentChanged = createAction<ChangedKontentRequest>(ProjectsActionTypes.ContentChanged);

export const contentChangedError = createAction(ProjectsActionTypes.ContentChangedError);

export const contentChangedSuccess = createAction(ProjectsActionTypes.ContentChangedSuccess);

export const contentChangedSend = createAction<ChangedKontentRequest>(ProjectsActionTypes.ContentChangedSend);

export const contentChangedIgnore = createAction<ChangedKontentRequest>(ProjectsActionTypes.ContentChangedIgnore);

export const contentRemovedRemove = createAction<{ jobIds: Array<string> }>(ProjectsActionTypes.ContentRemovedRemove);

export const contentRemovedRemoveError = createAction(ProjectsActionTypes.ContentRemovedRemoveError);

export const contentRemovedRemoveSuccess = createAction(ProjectsActionTypes.ContentRemovedRemoveSuccess);

export const contentRemovedIgnore = createAction<{ jobIds: Array<string> }>(ProjectsActionTypes.ContentRemovedIgnore);

export const contentRemovedIgnoreError = createAction(ProjectsActionTypes.ContentRemovedIgnoreError);

export const contentRemovedIgnoreSuccess = createAction(ProjectsActionTypes.ContentRemovedIgnoreSuccess);

export const errorMessageIgnore = createAction<JobsErrorCodeIgnoreDTO>(ProjectsActionTypes.ErrorMessageIgnore);

export const errorMessageIgnoreError = createAction(ProjectsActionTypes.ErrorMessageIgnoreError);

export const errorMessageIgnoreSuccess = createAction(ProjectsActionTypes.ErrorMessageIgnoreSuccess);

export const checkProject = createAction<IProjectCheckPayload>(ProjectsActionTypes.CheckProject);

export const checkProjectSuccess = createAction<ProjectCheckArray>(ProjectsActionTypes.CheckProjectSuccess);

export const checkProjectClear = createAction(ProjectsActionTypes.CheckProjectClear);

export const getProjectLanguages = createAction<string>(ProjectsActionTypes.GetProjectLanguages);

export const getProjectLanguagesError = createAction(ProjectsActionTypes.GetProjectLanguagesError);

export const getProjectLanguagesSuccess = createAction<Array<KontentProjectLanguageMappingDTO>>(
  ProjectsActionTypes.GetProjectLanguagesSuccess,
);

export const getProjectWorkflowSteps = createAction<string>(ProjectsActionTypes.GetProjectWorkflowSteps);

export const getProjectWorkflowStepsError = createAction(ProjectsActionTypes.GetProjectWorkflowStepsError);

export const getProjectWorkflowStepsSuccess = createAction<Array<XTMWorkflowStepDTO>>(
  ProjectsActionTypes.GetProjectWorkflowStepsSuccess,
);

export const checkErrorProjectSuccess = createAction<ProjectErrorArray>(ProjectsActionTypes.CheckErrorProjectSuccess);

export const checkErrorProjectClear = createAction(ProjectsActionTypes.CheckErrorProjectClear);

export const getProjectChangedContent = createAction<{ projectId: string; sort: boolean }>(
  ProjectsActionTypes.GetProjectChangedContent,
);

export const getProjectChangedContentError = createAction(ProjectsActionTypes.GetProjectChangedContentError);

export const getProjectChangedContentSuccess = createAction<Array<ChangedProductsDTO>>(
  ProjectsActionTypes.GetProjectChangedContentSuccess,
);

export const getXTMRequestersForProject = createAction<string>(ProjectsActionTypes.GetXTMRequestersForProject);

export const getXTMRequestersForProjectError = createAction(ProjectsActionTypes.GetXTMRequestersForProjectError);

export const getXTMRequestersForProjectSuccess = createAction<Array<IAutocompleteField>>(
  ProjectsActionTypes.GetXTMRequestersForProjectSuccess,
);

export const getXTMCustomersForUser = createAction(ProjectsActionTypes.GetXTMCustomersForUser);

export const getXTMCustomersForUserError = createAction(ProjectsActionTypes.GetXTMCustomersForUserError);

export const getXTMCustomersForUserSuccess = createAction<Array<IAutocompleteField>>(
  ProjectsActionTypes.GetXTMCustomersForUserSuccess,
);

export const setProjectSearch = createAction<string>(ProjectsActionTypes.SetProjectSearch);
